import React, { useState } from 'react';
import { LANGUAGES, useI18n } from '../i18n';

// Subtle pill that opens a dropdown of languages in their own script.
// `dark` restyles it for the dark portal nav bars.
export default function LanguageSwitcher({ dark }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <div className="lang-wrap">
      <button type="button" className={`lang-btn ${dark ? 'dark' : ''}`} onClick={() => setOpen(o => !o)} aria-label="Change language">
        {/* Globe drawn inline so it renders in brand gold (emoji can't be tinted) */}
        <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--blue)" strokeWidth="1.8" strokeLinecap="round">
          <circle cx="12" cy="12" r="9" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <ellipse cx="12" cy="12" rx="4.2" ry="9" />
        </svg>
        <span>{lang.toUpperCase()}</span>
      </button>
      {open && (
        <>
          <div className="lang-overlay" onClick={() => setOpen(false)}></div>
          <div className="lang-menu">
            {LANGUAGES.map(l => (
              <div
                key={l.code}
                className={`lang-item ${l.code === lang ? 'active' : ''}`}
                onClick={() => { setLang(l.code); setOpen(false); }}
              >
                <span>{l.name}</span>
                {l.code === lang && <span>✓</span>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
